export default __webpack_public_path__ + "static/media/slowforest.c2502bae.mp4";